
import React from 'react';
import { UserRole } from '../App';
import { BriefcaseIcon, UserIcon } from './icons';

interface RoleSwitcherProps {
  userRole: UserRole;
  setUserRole: (role: UserRole) => void;
}

const RoleSwitcher: React.FC<RoleSwitcherProps> = ({ userRole, setUserRole }) => {
  return (
    <div
      className="flex items-center gap-1 p-[3px] rounded-lg"
      style={{ background: '#F5F3F0', border: '1px solid #E8E4DF' }}
      data-tutorial-id="role-switcher"
    >
      <button
        onClick={() => setUserRole('researcher')}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-[11px] uppercase tracking-wider rounded-md transition-all active:scale-95 ${userRole === 'researcher' ? 'bg-white text-text-ink font-bold shadow-sm' : 'text-text-faint font-semibold hover:text-text-ink'}`}
      >
        <BriefcaseIcon className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Researcher</span>
      </button>
      <button
        onClick={() => setUserRole('participant')}
        className={`flex items-center gap-1.5 px-3 py-1.5 text-[11px] uppercase tracking-wider rounded-md transition-all active:scale-95 ${userRole === 'participant' ? 'bg-white text-text-ink font-bold shadow-sm' : 'text-text-faint font-semibold hover:text-text-ink'}`}
      >
        <UserIcon className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Participant</span>
      </button>
    </div>
  );
};

export default RoleSwitcher;
